import axios from 'axios';
import { handleTokenError } from '@/utils/tokenHandler';

// Получаем базовый URL из текущего домена
const getBaseUrl = () => {
    const origin = window.location.origin;
    // Убеждаемся что путь корректный для production
    return `${origin}/api/v1`;
};

const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL || getBaseUrl(),
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
    // Увеличиваем таймаут для медленных соединений
    timeout: 30000
});

// Add request interceptor
api.interceptors.request.use(
    config => {
        // Получаем токен из localStorage
        const token = localStorage.getItem('lbToken');
        
        if (token) {
            // Устанавливаем заголовок Authorization
            config.headers.Authorization = `Bearer ${token}`;
            
            // Если нет данных в запросе, создаем пустой объект
            if (!config.data) {
                config.data = {};
            }
            
            // Добавляем токен в тело запроса, если это объект
            if (typeof config.data === 'object' && !config.data.token) {
                config.data.token = token;
            }
        }
        
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// Функция обработки ошибок токена импортирована из tokenHandler

// Добавляем перехватчик для обработки ошибок
api.interceptors.response.use(
    response => {
        // Проверяем успешность ответа даже при статусе 200
        // Но только если сообщение об ошибке связано с токеном
        if (response.data && response.data.success === false) {
            const errorMessage = response.data.message || '';

            
            const isTokenRelated = errorMessage.includes('token') || 
                                 errorMessage.includes('Token') ||
                                 errorMessage.includes('Access denied') ||
                                 errorMessage.includes('Bad token') ||
                                 errorMessage.includes('Invalid Token') ||
                                 errorMessage.includes('Expired token') ||
                                 errorMessage.includes('not granted') ||
                                 errorMessage.includes('Not granted') ||
                                 errorMessage.includes('NOT GRANTED');
            

            
            if (isTokenRelated && handleTokenError({ response })) {

                return Promise.reject(new Error('Token validation failed'));
            }
        }
        return response;
    },
    error => {

        
        // Обрабатываем ошибки токена
        if (handleTokenError(error)) {

            return Promise.reject(new Error('Token validation failed'));
        }
        
        // Проверяем тип ошибки
        let errorMessage = 'Unknown error occurred';
        
        if (error.response) {
            // Сервер вернул ответ со статусом отличным от 2xx
            errorMessage = error.response.data?.message || `Server error: ${error.response.status}`;
        } else if (error.request) {
            // Запрос был сделан, но ответ не был получен
            errorMessage = 'No response from server. Please check your connection';
        } else {
            // Что-то произошло при настройке запроса
            errorMessage = error.message;
        }
        
        return Promise.reject({
            error,
            message: errorMessage,
            config: error.config,
            response: error.response
        });
    }
);


export default api;
